export default {
  supplierbanner: {
    subtitle: "للموردين",

    title1: "زد مبيعاتك.",
    title2: "إدارة الطلبات بسهولة.",

    desc:
      "تساعد MAHAL الموردين على التواصل مع المطاعم الموثوقة وإدارة الطلبات بكفاءة وتوسيع أعمالهم من خلال منصة B2B قوية.",

    cta: "انضم كمورد",
  },
};